var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    x: 2.5,
    y: 2.5,
    stroke: "#858282",
    strokeOpacity: 0.6,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#858282",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.6,
    d: "M6 10L10 6M10 6H6.92308M10 6V9.07692"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.874f9bd0b77500dc47045739c72cdb67.svg";
export { ForwardRef as ReactComponent };